<template>
  <div>
    <div style="font-size: 0; height: calc(100vh - 60px)">
      <img src="../assets/image/bg.gif" class="bgimg" />
    </div>
        <div
      :class="vedioShow ? 'big-video' : 'video'"
      @click="
        vedioShow = true;
        maskShow = true;
        commentShow();
      "
    >
      <video
        poster="../assets/image/first.png"
        v-if="!videoOpen"
        style="width: 100%; height: 100%"
        src="https://cadal.edu.cn/kid/1-1.mp4"
        controls
        preload="auto"
        autoplay="autoplay"
        data-setup="{'autoplay':true}"
        id="play_video"
      ></video>
    </div>
    <transition name="slide-fade">
      <div v-show="bigImg" :class="bigImg ? 'bigImg' : 'bigImg_hidden'">
        <img :src="bigImgSrc" style="width: 100%" />
        <a href="#" class="deletebox" @click="bigImg = false"></a>
      </div>
    </transition>
    <div
      class="mask"
      :style="maskShow ? '' : 'display: none;'"
      @click="commentClose"
    ></div>
    <div
      class="mask2"
      :style="bigImg ? '' : 'display: none;'"
      @click="bigImg = false"
    ></div>

    <div @mouseover="listBoxShow = true" class="listBox">
      <ul class="cf" id="carousel">
        <li
          ref="videoItem"
          v-for="(item, index) in videoList"
          v-bind:key="index"
          :class="videoSrc == item.image ? 'on' : ''"
          class="carousel-item"
        >
            <el-tooltip class="item" effect="dark" :content="item.title" placement="top">
                <img :src="item.image" alt="" style="width:100%;height:100%;margin:0;"  @click="videoClick(item.url, index)">
            </el-tooltip>
        </li>
      </ul>
    </div>
    <video-window
      :open="videoOpen"
      :index="videoIndex"
      @close="videoOpen = false"
    ></video-window>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import data from "@/mock/video.json"
export default {
  name: "HelloWorld",
  components: {
    videoWindow: () => import("./VideoWindow.vue"),
  },
  data() {
    return {
      scrollTop: 1000,
      pageNum: 1,
      pageSize: 10,
      maskShow: false,
      bigItem: -1,
      bigImg: false,
      bigImgSrc: "../assets/css/img/2.png",
      listBoxShow: false,
      vedioShow: false,
      videoOpen: false,
      videoIndex: 0,
      videoList: data.concat(data.slice(0,8)),
      videoSrc: "",
      timer: null,
    };
  },
  mounted() {
    this.initCarouselScroll(1);
    this.handleHover();
  },
  methods: {
    handleHover() {
      const carouselElem = document.getElementById("carousel");

      carouselElem.addEventListener(
        "mouseover",
        () => {
          this.timer && cancelAnimationFrame(this.timer);
        },
        false
      );

      carouselElem.addEventListener(
        "mouseout",
        () => {
          this.initCarouselScroll(1);
        },
        false
      );
    },
    initCarouselScroll(speed) {
      const boxWidth = document.querySelector(".listBox").offsetWidth; //盒子宽度
      const carouselWidth = document.getElementById("carousel").offsetWidth; //ul宽度
      const maxScroll = this.videoList.length > 8 ? document.querySelectorAll(".carousel-item")[this.videoList.length - 8].offsetLeft : boxWidth; //临界值
      const carouselElem = document.getElementById("carousel");
      // const maxScroll = carouselWidth - (itemWidth + 25) * 6;
      const setLeft = () => {
        if (carouselWidth > boxWidth) {
          const left = carouselElem.offsetLeft;
          carouselElem.style.left = left - speed + "px";
          if (Math.abs(left) >= maxScroll) {
            carouselElem.style.left = 0;
          }
          this.timer = requestAnimationFrame(setLeft);
        } else {
          this.timer && cancelAnimationFrame(this.timer);
        }
      };

      setLeft();
    },
    scrollEvent(e) {
      this.scrollTop = e.target.scrollTop + 1000;
    },
    pageChange(page) {
      this.pageNum = page;
      this.gotoTop("tab2Content");
    },
    gotoTop(divId) {
      this.bigItem = -1;
      this.$nextTick(() => {
        var container = this.$el.querySelector("#" + divId + "");
        container.scrollTop = 0;
        container.scrollLeft = 0;
      });
    },
    commentShow() {
      document.body.style.overflow = "hidden";
      this.bigItem = -1;
    },
    commentClose() {
      document.body.style.overflow = "auto";
      this.bigItem = -1;
      this.maskShow = false;
      this.vedioShow = false;
      this.tab6Show = false;
      this.tab4Show = false;
      this.tab3Show = false;
      this.tab2Show = false;
    },
    videoClick(src, index) {
      this.videoSrc = src;
      this.$nextTick(() => {
        this.$refs.videoItem[index].scrollIntoView({
          behavior: "smooth", // 平滑过渡
          inline: "center",
        });
        var that = this;
        setTimeout(() => {
          that.videoOpen = true;
          that.videoIndex = index%data.length
        }, 500);
      });
    },
    itemClick(ref, index) {
      this.$nextTick(() => {
        this.$el.querySelector(`#${ref}_${index}`).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          inline: "center",
        });
        var that = this;
        setTimeout(() => {
          that.contentIndex = index;
        }, 300);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/views/index.vue